import { TimesheetModel as Model } from './Model'


export const MODULE_NAME = 'scheduler'

export const SCHEDULER_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: SCHEDULER_ROUTES.LAYOUT,
  route: { name: SCHEDULER_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-message-text-outline',
} as const
